// extracted by mini-css-extract-plugin
export var backButton = "_1e-1";
export var content = "_1e-d";
export var continueButton = "_1e-7";
export var continueHint = "_1e-8";
export var continueRow = "_1e-6";
export var leftInner = "_1e-0";
export var shell = "_1e-e";
export var sidebarContent = "_1e-5";
export var skipButton = "_1e-c";
export var spacer = "_1e-2";
export var spin = "_1e-a";
export var spinner = "_1e-9";
export var spinnerOverlay = "_1e-b";
export var subtitle = "_1e-4";
export var title = "_1e-3";